import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'
import { BREAKPOINT } from 'app/sofia/resources/constants'
import { container, buttonPrimary, heading2, link } from 'app/sofia/resources/theme/css'

export const Container = styled.div`
  > div {
    ${container};
    padding: 50px 0 90px;

    @media (max-width: ${BREAKPOINT.MD}) {
      padding: 0 40px 70px;
    }
  }

  h2 {
    ${heading2}
    margin-bottom: 30px;
    ${bp('sm')`
      text-align: center;
    `}
  }

  .posts {
    &__wrapper {
      display: flex;
      justify-content: space-between;

      @media (max-width: ${BREAKPOINT.MD}) {
        flex-wrap: wrap;
      }
    }

    &__featured {
      position: relative;
      width: 100%;
      max-width: 1000px;
      overflow: hidden;

      img {
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        ${bp('sm')`
          min-width: unset;
          min-height: unset;
          width: 100%;
        `}
      }
    }

    &__overlay {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background: rgb(255, 255, 255);
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 45%, rgba(0, 0, 0, 1) 100%);
      color: ${props => props.theme.palette.general.light};
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-start;
      padding: 30px;
      ${bp('sm')`
        position: static;
        color: ${(props: any) => props.theme.palette.general.strong};
        background: transparent;
        padding: 20px 0 15px;
        border-bottom: 1px solid ${(props: any) => props.theme.palette.general.greyDark};
      `}

      h3 {
        font-size: 24px;
        margin: 0;
        line-height: 1.5;
        ${bp('sm')`
          font: ${font('default', 'light', '20px/1.5')};
          margin-bottom: 20px;
        `}
      }

      p {
        ${bp('sm')`
          display: none;
        `}
      }

      a {
        ${buttonPrimary}
        color: ${props => props.theme.palette.primary.alphaDark};
        font: ${font('default', 'bold', '16px/1')};
        background: ${props => props.theme.palette.general.light};
        border-color: ${props => props.theme.palette.general.light};
        ${bp('sm')`
          padding: 0;
          font-weight: bold;
        `}
      }
    }

    &__aside {
      margin-left: 30px;
      width: 100%;

      @media (max-width: ${BREAKPOINT.MD}) {
        margin: 25px 0 0;
      }
    }

    &__post {
      padding: 30px 32px;
      border-bottom: 1px solid ${props => props.theme.palette.general.greyDark};

      @media (max-width: ${BREAKPOINT.MD}) {
        padding: 20px 0 15px;
      }

      &:first-child {
        padding-top: 0;
      }

      p {
        font: ${font('default', 'light', '20px/1.5')};
        margin-top: 0;
      }

      a {
        ${link}
        text-decoration: none;
        font: ${font('default', 'bold', '16px/1')};
      }
    }
  }
`
